module.exports = __webpack_public_path__ + "static/media/M011-icon.fba85c46.svg";